import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './common/not-found/not-found.component';
import { AuthGuard } from './_helpers/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' }, // Default -> Login
  { path: 'login', loadChildren: () => import('./frontend/frontend.module').then(m => m.FrontendModule) },
  { path: 'eManager', loadChildren: () => import('./e-manager/e-manager.module').then(m => m.EManagerModule), canActivate: [AuthGuard] },
  { path: '**', component: NotFoundComponent } // 404 Page
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false, // Debugging off
      scrollPositionRestoration: 'enabled',
      useHash: false // ❌ Hash remove karega
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
